import { FC } from "react"
import { Stack, Text, TextInput, Checkbox, Button, Paper } from "@mantine/core"
import classes from "./styles.module.scss"
import { classNames } from "@/shared/lib/helpers/classNames"
import { IFormData } from "@/shared/types/formData"
import { sendMail } from "@/entities/form"
import { PhoneInput } from "../PhoneInput"
import { Link } from "react-router-dom"
import { selectPrivacyPolicy } from "@/entities/options/model/selectors"
import { useAppSelector } from "@/shared/lib/store"

interface ContactFormProps {
	title?: string
	subtitle?: string
	onSubmit?: (data: IFormData) => void
	bg?: string
	extraClasses?: string[]
	object?: string
	subject?: string
}

export const ContactForm: FC<ContactFormProps> = ({
	object,
	title = "Нужна помощь с подбором квартиры?",
	subtitle = "Оставьте свои контакты, и наш менеджер проконсультирует вас",
	bg = "dark.9",
	extraClasses,
	onSubmit,
	subject,
}) => {
	const privacyPolicy = useAppSelector(selectPrivacyPolicy)
	const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault()
		const formData = new FormData(event.currentTarget)

		const formDataObject: IFormData = {
			subject: String(formData.get("subject")),
			phone: String(formData.get("phone")),
			name: String(formData.get("name")),
			message: String(formData.get("object")),
		}

		sendMail(formDataObject)

		onSubmit?.(formDataObject)
	}

	return (
		<Paper className={classNames([classes.container, ...(extraClasses || [])])} radius={12} bg={bg}>
			<Stack gap={24}>
				<Stack gap={8}>
					<Text className={classes.title} fz={24} fw={500} lh={1.25} c="#fff" ta="center">
						{title}
					</Text>
					<Text
						className={classes.subtitle}
						c={"rgba(255, 255, 255, 0.70)"}
						fz={14}
						lh={1.42}
						ta="center"
					>
						{subtitle}
					</Text>
				</Stack>

				<form onSubmit={handleSubmit}>
					<Stack gap={24}>
						<Stack gap={12}>
							<input hidden name="subject" value={subject || title} />
							{object && <input hidden name="object" value={object} />}
							<TextInput
								name="name"
								variant="filled"
								placeholder="Ваше имя"
								className={classes.input}
							/>

							<PhoneInput
								c="#636363"
								name="phone"
								placeholder="Телефон"
								required
								variant="filled"
								className={classes.input}
							/>

							{privacyPolicy && (
								<Checkbox
									variant="outline"
									name="consent"
									color="rgba(255, 255, 255, 1)"
									classNames={{
										input: classes.checkboxInput,
									}}
									label={
										<Text c="rgba(255, 255, 255, 0.70)" fz={12} lh={1.42} className={classes.label}>
											Соглашаюсь с{" "}
											<Link to="/privacy" target="_blank" className={classes.anchor}>
												политикой обработки персональных данных
											</Link>
										</Text>
									}
									required
									className={classes.checkbox}
								/>
							)}
						</Stack>

						<Button
							variant="white"
							type="submit"
							p={0}
							h={50}
							className={classes.submitButton}
							fullWidth
						>
							Отправить
						</Button>
					</Stack>
				</form>
			</Stack>
		</Paper>
	)
}
